import { Col, Grid, Pagination, type PaginationProps, Row } from 'antd';
import { DEFAULT_PER_PAGE, PAGE_SIZE_OPTIONS } from 'mdc-constants';
import { FC } from 'react';
import styles from './PagePagination.module.scss';

type RequiredProps = Required<Pick<PaginationProps, 'total' | 'current' | 'onChange' | 'pageSize'>>;
type OptionalProps = Omit<PaginationProps, keyof RequiredProps>;

interface PagePaginationProps extends RequiredProps, OptionalProps {
  /** Label to call sum of items, default: `records` */
  label?: string;
  /** First item of list, default: `1` */
  firstItem?: number | null;
  /** Last item of list, default: `1` */
  lastItem?: number | null;
  className?: string;
  customPagePagination?: number[];
}

const PagePagination: FC<PagePaginationProps> = ({
  total,
  current,
  firstItem = 1,
  lastItem = 1,
  label = 'records',
  pageSize = DEFAULT_PER_PAGE,
  className,
  customPagePagination,
  ...rest
}) => {
  const { sm, md } = Grid.useBreakpoint();

  if (!total) {
    return null;
  }

  return (
    <Row
      className={`${className || ''} ${styles.paginationRow}`}
      justify={sm ? 'space-between' : 'center'}
      align="middle"
    >
      <Col>
        <p className={styles.paginationInfo}>
          Viewing {firstItem} - {lastItem} of {total} {label}
        </p>
      </Col>

      <Col>
        <Pagination
          showSizeChanger
          defaultCurrent={1}
          pageSizeOptions={customPagePagination || PAGE_SIZE_OPTIONS}
          size={md ? 'medium' : 'small'}
          total={total}
          current={current}
          pageSize={pageSize}
          {...rest}
        />
      </Col>
    </Row>
  );
};

export default PagePagination;
